import { render, staticRenderFns } from "./FormPreferredDeliveryAddress.vue?vue&type=template&id=7dafacce"
import script from "./FormPreferredDeliveryAddress.vue?vue&type=script&lang=js"
export * from "./FormPreferredDeliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormPreferredDeliveryAddress.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dafacce')) {
      api.createRecord('7dafacce', component.options)
    } else {
      api.reload('7dafacce', component.options)
    }
    module.hot.accept("./FormPreferredDeliveryAddress.vue?vue&type=template&id=7dafacce", function () {
      api.rerender('7dafacce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormPreferredDeliveryAddress.vue"
export default component.exports